// L'Atelier 33 — Botón "Comprar ahora": agrega la talla elegida y va DIRECTO al pago.
//
// Por qué a mano y no con el botón acelerado de Shopify: ese (Shop Pay / PayPal) se quitó de la
// tienda a propósito el 2026-08-18. Este hace lo que Yeremi pidió —saltarse el carrito— pero con
// el checkout normal, donde están todos los métodos de pago (incluido OXXO dentro de Mercado Pago).
//
// ⚠ TOCA EL CAMINO DE COMPRA (regla 10): cualquier cambio aquí se prueba con navegador real
// comprobando que se llega a /checkouts/, no solo que el botón responde.
(() => {
  const SEL = '[data-lat-comprar-ahora]';

  async function comprarAhora(boton) {
    const form = boton.closest('form[action*="/cart/add"]');
    if (!form || boton.dataset.cargando === '1') return;

    boton.dataset.cargando = '1';
    const textoOriginal = boton.textContent;
    boton.setAttribute('aria-busy', 'true');
    boton.textContent = boton.dataset.textoCargando || 'Un momento…';

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });
      if (!res.ok) throw new Error('add ' + res.status);
      // A /checkout, no a /cart: es justo lo que se pidió, saltarse el carrito.
      window.location.assign('/checkout');
    } catch (e) {
      // Si algo falla (sin talla elegida, sin stock, red caída) la clienta no se queda colgada:
      // se restaura el botón y se deja que el flujo normal del carrito haga su trabajo.
      console.error('[lat-comprar-ahora]', e);
      boton.dataset.cargando = '0';
      boton.removeAttribute('aria-busy');
      boton.textContent = textoOriginal;
    }
  }

  // Delegado en el documento: el modal de compra rápida INYECTA la ficha después de cargar la
  // página, así que un listener puesto botón por botón al arrancar no lo alcanzaría.
  document.addEventListener('click', (e) => {
    const boton = e.target.closest(SEL);
    if (!boton) return;
    e.preventDefault();
    comprarAhora(boton);
  });
})();
